import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { RELATED_STATS } from '../../../config/related-stats';
import { STATS } from '../../../config/stats';
import { statsLeadersDataTypeSelector } from '../../../../../../../store/js/modules/statspro/stats-leaders/selectors';

const CLASS_BLOCK = 'player-stats-tooltip-related-stats';

/**
 * @param {object} props - Props.
 * @param {object} props.row - Row.
 * @param {object} props.cell - Cell.
 * @param {object} props.player - Player.
 * @param {object} [props.benchmark] - Benchmark.
 * @returns {JSX.Element} Component.
 */
export const PlayerStatsTooltipRelatedStats = props => {
    const stat = props.cell.column.id;
    const dataType = useSelector( statsLeadersDataTypeSelector );

    return (
        <ul className={ CLASS_BLOCK }>
            { RELATED_STATS[ stat ].map( relatedStat => {
                const relatedStatValue = props.player.stats[ dataType.type ][ relatedStat ];
                return (
                    <li key={ relatedStat } className={ `${ CLASS_BLOCK }__item` }>
                        <span className={ `${ CLASS_BLOCK }__name` }>{ STATS[ relatedStat ].name }</span>
                        <span className={ `${ CLASS_BLOCK }__value` }>{ relatedStatValue.value ?? relatedStatValue }</span>
                    </li>
                );
            } ) }
        </ul>
    );
};

PlayerStatsTooltipRelatedStats.propTypes = {
    row: PropTypes.object.isRequired,
    cell: PropTypes.object.isRequired,
    player: PropTypes.object.isRequired,
    benchmark: PropTypes.string
};